import config from 'config/config'
import * as log from 'loglevel';
import * as sentry from '@sentry/browser';

export const configure = () => {
  // this is a second initialisation of the sentry sdk for explicit use,
  // in addition to the sentry redux middleware used elsewhere
  sentry.init({
    dsn: config.sentryURL,
    environment: config.environment,
    ...config.sentryOptions
  });

  // this is a wee loglevel plugin that allows us to log multiple values
  // like what other logging libraries do, and if the log level is error
  // also reports the error to sentry. if the first value passed to the log
  // function is an Error, that gets reported, otherwise a new Error is created
  // and reported.
  const originalFactory = log.methodFactory;

  log.methodFactory = (methodName, logLevel, loggerName) => {

    const rawMethod = originalFactory(methodName, logLevel, loggerName);

    if (logLevel === 'error') {
      return (...message) => {
        const e = message[0];
        if (e instanceof Error) {
          sentry.captureException(e);
          message.shift();
          rawMethod(e.getMessage() + message.join(' '));
        } else {
          sentry.captureException(new Error(message.join(' ')));
          rawMethod(message.join(' '));
       }
      };
    } else {
      return (...message) => {
        rawMethod(message.join(' '));
      };
    }
  };

   // apply plugin by setting level
  log.setLevel('info');
  log.info("Logging has been configured");
};
